import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider, useAuth } from "./lib/auth.js";
import { AppLayout } from "./components/AppLayout.js";
import { LoginPage } from "./pages/LoginPage.js";
import { DashboardPage } from "./pages/DashboardPage.js";
import { PortfolioPage } from "./pages/PortfolioPage.js";
import { AnalysesPage } from "./pages/AnalysesPage.js";
import { AnalysisPage } from "./pages/AnalysisPage.js";
import { CandidatePage } from "./pages/CandidatePage.js";
import { JobsPage } from "./pages/JobsPage.js";
import { SimulationsPage } from "./pages/SimulationsPage.js";
import { SimulationEditorPage } from "./pages/SimulationEditorPage.js";
import { SimulationPage } from "./pages/SimulationPage.js";
import { DataHealthPage } from "./pages/DataHealthPage.js";
import "./styles.css";
import "./pages/DataHealthPage.css";

function ProtectedRoutes() {
  const {user, loading} = useAuth();
  if (loading) return <div className="app-loading"><span className="brand-mark">S</span><p>Loading review workspace…</p></div>;
  if (!user) return <Navigate to="/login" replace />;
  return <AppLayout><Routes>
    <Route path="/" element={<PortfolioPage />} />
    <Route path="/research" element={<DashboardPage />} />
    <Route path="/analyses" element={<AnalysesPage />} />
    <Route path="/analyses/:runId" element={<AnalysisPage />} />
    <Route path="/analyses/:runId/candidates/:cik/:symbol" element={<CandidatePage />} />
    <Route path="/jobs" element={<JobsPage />} />
    <Route path="/data-health" element={<DataHealthPage />} />
    <Route path="/playground" element={<SimulationsPage />} />
    <Route path="/playground/new" element={<SimulationEditorPage />} />
    <Route path="/playground/:simulationId" element={<SimulationPage />} />
    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes></AppLayout>;
}

function App() {
  const {user} = useAuth();
  return <Routes>
    <Route path="/login" element={user ? <Navigate to="/" replace /> : <LoginPage />} />
    <Route path="*" element={<ProtectedRoutes />} />
  </Routes>;
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode><BrowserRouter><AuthProvider><App /></AuthProvider></BrowserRouter></React.StrictMode>,
);
